import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateRange, DateRangePicker as MuiDateRangePicker } from "@mui/x-date-pickers-pro";
import React, { FC, useState } from "react";
import {Box} from "@material-ui/core";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Backdrop, TextField as MuiTextField } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled('div')`
   display: flex;
   justify-content: center;
   align-items: center;
   margin-left: 17px;
   margin-right: 14px;
 `

const TextField = styled(MuiTextField)`
   & label {
     font-size: 13px;
     color: #FFFFFF;
     transform: translate(13px, 13px) scale(1);
   }
   & .MuiFormLabel-filled {
     display: none;
   }
   & .MuiOutlinedInput-root {
     width: 114px;
     border-radius: 8px;
     background: #233145;
     & fieldset {
       border-color: rgba(255, 255, 255, 0.23);
     }
     & label {
       color: #FFFFFF
     }
     &:hover fieldset {
       border-color: white;
     }
   }
   & .MuiInputBase-input {
     font-size: 13px;
     color: #FFFFFF;
     padding: 12px 12px;
     max-width: 120px;
   }
 `

const DateRangePicker = styled(MuiDateRangePicker)`
   background-color: rgba(27, 38, 53, 1);
   color: rgba(255, 255, 255, 1);
   & .css-1tape97 {
     margin: 0 10px;
     & .MuiPickersArrowSwitcher-root {
       border-bottom: 1px solid rgba(224, 224, 224, 1);
       padding-bottom: 10px;
       margin-bottom: 10px;
     },
   },
   & .css-1tape97:not(:last-of-type) {
     border-right: none
   },
   & .MuiPickersDay-today:not(.Mui-selected) {
     border: 1px solid rgb(107 109 112)
   },
   & .MuiButtonBase-root {
     color: rgba(255, 255, 255, 1)
   },
   & .MuiDateRangePickerDay-dayInsideRangeInterval {
     color: rgba(27, 38, 53, 1)
   },
   & .MuiTypography-caption {
     color: rgba(129, 129, 129, 1)
   },
   & .MuiDateRangePickerDay-rangeIntervalDayHighlight {
     background: rgb(141,147,154)
   },
  `


type PropsType = {
  selectedDate: DateRange<Date>
  setSelectedDate: (date: DateRange<Date>) => void
}

const CustomDateRangePicker: FC<PropsType> = ({selectedDate, setSelectedDate}) => {
  const {t} = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        localeText={{
          start: t('statsPage_Filter_data_from'),
          end: t('statsPage_Filter_data_to')
        }}
      >
        <DateRangePicker
          value={selectedDate}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          onChange={(date: DateRange<any>) => {
            setSelectedDate(date);
          }}
          renderInput={(startProps, endProps) => (
            <Container>
              <TextField
                {...startProps}
                style={{ zIndex: isOpen ? 1202 : 0 }}
                InputLabelProps={{shrink: false}}
              />
              <Box mx={2} style={{fontSize: '13px'}}> {t('statsPage_to')} </Box>
              <TextField
                {...endProps}
                style={{ zIndex: isOpen ? 1202 : 0 }}
                InputLabelProps={{shrink: false}}
              />
            </Container>
          )}
        />
        <Backdrop open={isOpen} style={{ color: "#fff", zIndex: 1201 }}/>
      </LocalizationProvider>
    </>
  )
}

export default CustomDateRangePicker
